import {checkOgrnOgrnip} from './ogrnValidation';

/** Функция проверки ИНН юрлиц, ИП
 * @param {string} inn - строка для проверки
 * @return boolean
 */
export const checkInn = (inn: string) => {
  if (
    typeof inn !== 'string' ||
    (inn.length !== 10 && inn.length !== 12) ||
    inn.split('').some((symbol) => isNaN(Number(symbol)))
  )
    return false;

  if (inn.length === 10) {
    return (
      Number(inn[9]) ===
      (inn
        .split('')
        .slice(0, -1)
        .reduce((summ, symbol, index) => [2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ, 0) %
        11) %
        10
    );
  } else if (inn.length === 12) {
    const checkSumOne =
      (inn
        .split('')
        .slice(0, -2)
        .reduce((summ, symbol, index) => [7, 2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ, 0) %
        11) %
      10;

    const checkSumTwo =
      (inn
        .split('')
        .slice(0, -1)
        .reduce((summ, symbol, index) => [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ, 0) %
        11) %
      10;

    return checkSumOne === Number(inn[10]) && checkSumTwo === Number(inn[11]);
  }
};

export const validateInn = (inn: string | undefined, ogrn?: string) =>
  !inn || inn.length === 0
    ? true
    : checkInn(inn) && inn.length === 10 && ogrn && checkOgrnOgrnip(ogrn) && ogrn.length === 15
      ? 'Нельзя указать ИНН юр. лица вместе с ОГРНИП'
      : checkInn(inn) && inn.length === 12 && ogrn && checkOgrnOgrnip(ogrn) && ogrn?.length === 13
        ? 'Нельзя указать ИНН инд. предпринимателя вместе с ОГРН'
        : checkInn(inn) || 'Некорректный ИНН';
